(() => {
  'use strict';
  const theme = document.body.hasAttribute('data-wishlist-store');
  // Gecko's existing browser-local wishlist format. Never cross origin.
  const key = 'nt_wis', cacheKey = 'monaco_wishlist_products_v1';
  let page = document.querySelector('[data-wishlist-page]');
  if (!page && document.body.classList.contains('pdp-page')) {
    const anchor = document.querySelector('.pdp-related') || document.querySelector('.pdp-details');
    if (anchor) {
      page = document.createElement('section'); page.className = 'pdp-wishlist';
      page.setAttribute('data-wishlist-page',''); page.setAttribute('aria-labelledby','pdp-wishlist-title');
      page.innerHTML = '<div class="pdp-related-head"><h2 id="pdp-wishlist-title" tabindex="-1">YOUR WISH LIST</h2><a href="/pages/wishlist">View wishlist</a></div><p data-wishlist-empty>Your wishlist is empty. Select a product heart to save it here.</p><div class="wishlist-items" data-wishlist-items tabindex="0" role="region" aria-label="Saved products"></div>';
      anchor.after(page);
    }
  }
  const buttons = new Map(), products = new Map();
  let catalogPromise;
  const detailRequests = new Map();
  const status = document.createElement('p');
  status.className = 'wishlist-status'; status.setAttribute('role','status');
  document.body.append(status);
  const announce = message => { status.textContent = message; };
  function ids() { return [...new Set((localStorage.getItem(key)||'').split(',').filter(x=>/^id:\d+$/.test(x)))]; }
  function saved(id) { try { return ids().includes('id:'+id); } catch { return false; } }
  function metadata(p) {
    const id = String(p.id || ''); if (!/^\d+$/.test(id)) return null;
    return {id,handle:p.handle,title:p.title,available:typeof p.available==='boolean'?p.available:undefined,price:Number.isFinite(p.price)?p.price:undefined,compareAtPrice:Number.isFinite(p.compare_at_price)?p.compare_at_price:undefined,priceVaries:p.price_varies===true, image: typeof p.image==='string'?p.image:p.image?.src || p.images?.[0]?.src || p.featured_image || '',url:'/products/'+p.handle};
  }
  async function catalog() {
    if (!catalogPromise) catalogPromise = fetch('/wishlist-catalog.json').then(r=>{if(!r.ok)throw Error();return r.json();}).then(rows=>{rows.forEach(p=>products.set(String(p.id),p));return rows;}).catch(()=>[]);
    return catalogPromise;
  }
  async function resolve(handle,id,card) {
    if (!theme) {
      await catalog();
      const known=products.get(String(id)) || [...products.values()].find(p=>p.handle===handle);
      if(known)return known;
      if(card?.matches('.watch-card') && /^\d+$/.test(id||'') && handle){
        const link=card.querySelector('a[href*="/products/"]'),title=card.querySelector('h3')?.textContent.trim();
        const url=new URL(link?.href||'',location.origin);
        if(title && [location.origin,'https://www.monacojewelers.com'].includes(url.origin)){
          const p={id:String(id),handle,title,image:card.querySelector('img')?.src||'',url:url.href};
          products.set(p.id,p);return p;
        }
      }
      return null;
    }
    if (products.has(String(id))) return products.get(String(id));
    if (!/^[a-z0-9-]+$/i.test(handle||'')) throw Error('No product handle');
    const response = await fetch('/products/'+handle+'.js'); if(!response.ok)throw Error('Product unavailable');
    const p=metadata(await response.json()); if(!p)throw Error('Product unavailable'); products.set(p.id,p); return p;
  }
  async function details(handle,id) {
    const p=await resolve(handle,id);
    if(!p || !theme)return p;
    if(!detailRequests.has(p.id))detailRequests.set(p.id,(async()=>{
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
      try{
        const response=await fetch('/products/'+p.handle+'?view=preview-wishlist-data',{credentials:'same-origin',signal:controller.signal});
        if(!response.ok)throw Error('Wishlist details unavailable');
        const data=await response.json();
        if(String(data.id)!==p.id || typeof data.card!=='string' || typeof data.soldLabel!=='string')throw Error('Invalid wishlist details');
        const fragment=new DOMParser().parseFromString(data.card,'text/html');
        const source=fragment.querySelector('.clp-card');
        if(source?.dataset.productId!==p.id)throw Error('Invalid wishlist product');
        const badge=source.querySelector('[data-inventory-badge],.clp-sold');
        p.wishlistBadge=badge ? {kind:badge.classList.contains('clp-sold')?'sold':badge.dataset.inventoryBadge,text:badge.classList.contains('clp-sold')?data.soldLabel:badge.textContent.trim()} : null;
        return p;
      }catch{return p;}finally{clearTimeout(timer);}
    })());
    const detailed=await detailRequests.get(p.id);
    products.set(p.id,detailed);
    return detailed;
  }
  function sync() {
    buttons.forEach((p,b)=> { const selected=saved(p.id); b.setAttribute('aria-pressed',String(selected)); b.setAttribute('aria-label',(selected?'Remove ':'Add ')+p.title+(selected?' from':' to')+' wishlist'); b.title=b.getAttribute('aria-label'); });
    try {
      const count=ids().length;
      document.querySelectorAll('[data-wishlist-count],.jswcount').forEach(n=>n.textContent=String(count));
      document.querySelectorAll('.header-actions a[href*="/pages/wishlist"]').forEach(a=>{
        const badge=a.querySelector('.header-count'); if(badge)badge.textContent=String(count);
        a.dataset.countLabel ||= a.getAttribute('aria-label') || 'Wishlist';
        a.setAttribute('aria-label',a.dataset.countLabel+' ('+count+')');
      });
    } catch {
      document.querySelectorAll('.header-actions a[href*="/pages/wishlist"] .header-count').forEach(n=>n.textContent='–');
    }
  }
  function toggle(p) {
    try {
      const current=ids(),entry='id:'+p.id, selected=current.includes(entry);
      // Cache only product metadata, never customer information. Save it first so
      // storage failures never claim that an item was successfully added.
      const cache=JSON.parse(localStorage.getItem(cacheKey)||'{}'); cache[p.id]=p;
      localStorage.setItem(cacheKey,JSON.stringify(cache));
      localStorage.setItem(key,(selected?current.filter(x=>x!==entry):[...current,entry]).join(','));
      sync(); if(page)render(); announce(selected?'Removed from wishlist.':'Added to wishlist.');
    } catch { announce('Your browser could not save this wishlist. Allow site storage and try again.'); }
  }
  function heart(host,p) {
    const b=document.createElement('button'); b.type='button'; b.className='wishlist-heart';
    b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
    b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();toggle(p);});
    buttons.set(b,p); host.classList.add('wishlist-host');host.append(b);sync();
  }
  async function scan() {
    for (let card of document.querySelectorAll('.clp-card,.watch-card,.pdp-related-list>li,.product-card,.product-detail,.pdp-gallery-stage')) {
      if(card.dataset.wishlistReady || card.closest('[data-wishlist-page]'))continue;
      card.dataset.wishlistReady='true';
      const link=card.querySelector('a[href*="/products/"]') || (card.matches('a')?card:null);
      let handle=link?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
      if(card.matches('.pdp-gallery-stage'))handle=location.pathname.match(/\/products\/([^/]+)/)?.[1];
      if(!handle && typeof CATALOG!=='undefined') { const name=card.querySelector('h3')?.textContent; handle=CATALOG.find(p=>p.name===name)?.url?.match(/\/products\/([^/?#]+)/)?.[1]; }
      const id=card.dataset.productId||card.dataset.resultId;
      try {
        const p=await resolve(handle,id,card);if(!p)continue;
        if(card.matches('button,a')) {const wrapper=document.createElement('div');wrapper.className='wishlist-card-wrap';card.before(wrapper);wrapper.append(card);card=wrapper;}
        heart(card,p);
      } catch { /* Product cannot be verified: do not offer a nonfunctional heart. */ }
    }
    for(const b of buttons.keys())if(!b.isConnected)buttons.delete(b);
  }
  let renderSequence=0;
  async function render() {
    if(!page)return;
    const sequence=++renderSequence,list=page.querySelector('[data-wishlist-items]'),empty=page.querySelector('[data-wishlist-empty]');
    let selected,cache;
    try {selected=ids();cache=JSON.parse(localStorage.getItem(cacheKey)||'{}');}catch{empty.hidden=false;empty.textContent='Allow site storage to use your wishlist.';return;}
    list.setAttribute('aria-busy','true');
    empty.hidden=selected.length>0;
    if(!theme)await catalog();
    if(theme) {
      await Promise.all(selected.map(entry=>{const id=entry.slice(3);return details(cache[id]?.handle,id).catch(()=>null);}));
    }
    if(sequence!==renderSequence)return;
    const restoreFocus=list.contains(document.activeElement);
    list.replaceChildren(); list.removeAttribute('aria-busy'); empty.hidden=selected.length>0;
    for(const entry of selected){
      const id=entry.slice(3),p=products.get(id)||cache[id];
      const card=document.createElement('article');card.className='wishlist-item';
      const current=theme ? products.get(id) : null;
      const inline=page.classList.contains('pdp-wishlist'),title=document.createElement(p?'a':'span');
      if(p){
        title.href=p.url;if(p.url?.startsWith('https://')){title.target='_blank';title.rel='noopener';}
        if(inline){
          title.className='pdp-related-card';
          const photo=document.createElement('div');photo.className='pdp-related-photo';
          if(current?.wishlistBadge){
            const row=document.createElement('div');row.className='pdp-related-badge-row';
            const badge=document.createElement('span');badge.className='pdp-related-badge wishlist-detail-badge';badge.dataset.inventoryBadge=current.wishlistBadge.kind;badge.textContent=current.wishlistBadge.text;row.append(badge);photo.append(row);
          }
          const image=document.createElement('span');image.className='pdp-related-image';
          if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';image.append(img);}
          photo.append(image);title.append(photo);
          const heading=document.createElement('h3');heading.textContent=p.title;title.append(heading);
        }else{
          if(p.image){const img=document.createElement('img');img.src=p.image;img.alt='';img.loading='lazy';card.append(img);}
          title.textContent=p.title;
          if(current?.wishlistBadge){const badge=document.createElement('div');badge.className='wishlist-detail-badge';badge.dataset.inventoryBadge=current.wishlistBadge.kind;badge.textContent=current.wishlistBadge.text;card.prepend(badge);}
        }
      }else title.textContent='Saved product '+id;
      if(Number.isFinite(current?.price)) {
        const currency=window.Shopify?.currency?.active || document.querySelector('.pdp-currency')?.textContent.trim();
        const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:/^[A-Z]{3}$/.test(currency||'')?currency:'USD',maximumFractionDigits:2,minimumFractionDigits:0});
        const price=document.createElement('p');price.className='pdp-related-price pdp-wishlist-price';
        const value=document.createElement('strong');value.textContent=(current.priceVaries?'From ':'')+money.format(current.price/100);price.append(value);
        if(!current.priceVaries && current.compareAtPrice>current.price){const regular=document.createElement('s');regular.textContent=money.format(current.compareAtPrice/100);price.append(regular);}
        if(inline)title.append(price);else card.append(price);
      }
      if(!inline && card.querySelector('.pdp-wishlist-price'))card.querySelector('.pdp-wishlist-price').before(title);else card.append(title);
      heart(card,p||{id,title:'saved product '+id});list.append(card);
    }
    if(restoreFocus)(list.querySelector('.wishlist-heart')||page.querySelector('h1,h2')).focus({preventScroll:true});
    if(theme && selected.some(entry=>!cache[entry.slice(3)])) {
      const legacy=document.createElement('a');legacy.href='/search/?view=wish&type=product&options[unavailable_products]=last&q='+encodeURIComponent(selected.join(' OR '));legacy.textContent='View details for previously saved products';list.append(legacy);
    }
  }
  document.querySelectorAll('a[href*="/pages/wishlist"],a[href*="view=wish"]').forEach(a=>{a.href='/pages/wishlist';a.removeAttribute('target');});
  // Keep the wishlist reachable even when a retained header has no heart link.
  const navigation=document.querySelector('.header-actions');
  if(navigation&&!navigation.querySelector('a[href="/pages/wishlist"]')){const a=document.createElement('a');a.href='/pages/wishlist';a.className='header-action wishlist-link';a.textContent='♡';a.setAttribute('aria-label','View wishlist');navigation.append(a);}
  let pending=false;
  const observer=new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;scan();});}});
  const main=document.querySelector('main')||document.body;
  observer.observe(main,{childList:true,subtree:true});
  document.querySelectorAll('#detail-content,#search-results').forEach(root=>{if(!main.contains(root))observer.observe(root,{childList:true,subtree:true});});
  window.addEventListener('storage',e=>{if(e.key===key||e.key===null){sync();render();}});
  window.addEventListener('pageshow',()=>{sync();render();});
  window.addEventListener('focus',sync);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync();});
  sync();scan();render();
})();



